import isProd from '~/utils/isProd';

export const TOURS_COMMAND_CENTRE_ALLOWED_EMAILS: ReadonlyArray<string> = [
  'jacob.meyer@luxuryescapes.com',
  'ming.chong@luxuryescapes.com',
  'mark.ma@luxuryescapes.com',
  'jake.pajer@luxuryescapes.com',
  'prahar.dosani@luxuryescapes.com',
  'richard.biddle@luxuryescapes.com',
  'declan.mcgann@luxuryescapes.com',
  'leopoldo.giovanetti@luxuryescapes.com',
  'oliver.banks@luxuryescapes.com',
];

const allowedEmails = new Set(TOURS_COMMAND_CENTRE_ALLOWED_EMAILS);

export function isToursCommandCentreEnabled(user: { email?: string | null } | null | undefined): boolean {
  if (!user) {
    return false;
  }

  if (!isProd()) {
    return true;
  }

  return Boolean(user.email && allowedEmails.has(user.email.trim().toLowerCase()));
}
